//@flow
import React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import Sidebar from "./Sidebar"

export const matchPath = (
  pathname: ?string,
  to: string,
  exact: boolean
): boolean => {
  if (!pathname) {
    return false
  }
  return exact ? pathname === to : pathname.match(new RegExp(`^${to}`)) !== null
}

export { Sidebar }

export const StyleableLink = ({
  className,
  children,
  to
}: {
  className: string,
  children: React$Element<any>,
  to: string
}) =>
  <Link className={className} to={to}>
    {children}
  </Link>

export const StyleableIcon = ({
  className,
  children,
  ...props
}: {
  className: string,
  children: React$Element<any>
}) =>
  <span className={className} {...props} role="img">
    {children}
  </span>

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const NavLink = styled(StyleableLink)`
  background: ${props =>
    matchPath(props.pathname, props.to, props.exact) ? "#fff" : "transparent"};
  padding: 1.1rem 1rem 1rem 1.5rem;
  color: ${props =>
    matchPath(props.pathname, props.to, props.exact)
      ? props.theme.backgroundGradientDark
      : "#fff"};
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NavSpacer = styled.div`flex-grow: 1;`

export const Icon = styled(StyleableIcon)`
  display: block;
  padding-right: 1rem;
  font-size: 2rem;
`



// WEBPACK FOOTER //
// ./src/UI/Sidebar/index.js